<template>
<div class="pwarrow_box">
  <v-card-text>
  <h5 class="accent--text" style="font-size: 12px; font-weight:700"> Pending Warrants </h5>
  <table class="table">
    <thead class="thead">
      <tr>
        <th scope="col">Lot Number</th>
        <th scope="col">Outturn</th>
        <th scope="col">Mark</th>
        <th scope="col">Grade</th>
        <th scope="col">Bags</th>
        <th scope="col">Pockets</th>
        <th scope="col">Total Weight</th>
        <th scope="col">Marketer</th>
        <th scope="col">Status</th>
        <th scope="col">Date</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in paginatedFiles" v-bind:key="item.id">
        <td> {{ item.lotNumber }} </td>
        <td> {{ item.outTurn }} </td>
        <td> {{ item.marks }} </td>
        <td> {{ item.grade }} </td>
        <td> {{ item.numberOfBags }}</td>
        <td> {{ item.numberOfPocket }}</td>
        <td> {{ item.weight }}</td>
        <td> {{ item.marketer.organisationName }}</td>
        <td> {{ item.status.statusName }}</td>
        <td> {{ item.created | prettyDate }}</td>
      </tr>
    </tbody>
  </table>
  </v-card-text>
  <v-card-actions>
    <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
    <v-spacer></v-spacer>
    <v-pagination
    v-model="page"
    :length="numberOfLinks"
    :total-visible="7"
    color="secondary"
                class="accent--text logoutbtn"
  ></v-pagination>
  </v-card-actions>
</div>
</template>
<script>
import axios from 'axios'
import config from '../../config'

export default {
  name: 'PendingWarrantsDash',
  data: function () {
    return {
      items: [],
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 5,
      page: 1,
      permissions: []
    }
  },
  mounted () {
    this.getDataFromApi()
  },
  watch: {
    items: function () {
      this.paginatedFiles = this.paginationMethod(this.items, 1, this.numberOfItemsPerPage)
      this.numberOfLinks = Math.ceil(this.items.length / this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(this.items, val, this.numberOfItemsPerPage)
    }
  },
  methods: {
    getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const items = this.getWarrants()
        const total = items.length
        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    getWarrants () {
      const url = config.serverURI + '/warrant/unconfirmed'
      axios.get(url)
        .then(response => {
          this.items = response.data
          this.$emit('updatePendingWarrantsCount', this.items.length)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error.response)
          this.message = error.response.status
          this.snackbar = true
          this.snackbarColor = 'error'
        })
      return this.items
    }
  }
}
</script>
<style>
.pwarrow_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
  border-radius: 5px;
}
.pwarrow_box:after, .pwarrow_box:before {
  bottom: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.pwarrow_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #fff;
  border-width: 20px;
  margin-left: -20px;
}
.pwarrow_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-bottom-color: #707070;
  border-width: 21px;
  margin-left: -21px;
}
</style>
